<template>
    <sub-menu :links="links" :active="active"></sub-menu>
</template>

<script>
    import Meta from '@/mixins/Meta'
    import SubMenu from '@/components/Layout/SubMenu'

    export default {
        components: {SubMenu},

        mixins: [Meta],

        props: ['person'],

        computed: {
            links() {
                return [
                    {
                        id: 'dashboard',
                        url: '/people/' + this.person.data.id,
                        text: 'Dashboard'
                    },
                    {
                        id: 'edit',
                        url: '/people/' + this.person.data.id + '/edit',
                        text: 'Edit'
                    },
                    {
                        id: 'subscriptions',
                        url: '/people/' + this.person.data.id + '/subscriptions',
                        text: 'Subscriptions'
                    },
                    {
                        id: 'invoices',
                        url: '/people/' + this.person.data.id + '/invoices',
                        text: 'Invoices'
                    },
                    {
                        id: 'emails',
                        url: '/people/' + this.person.data.id + '/emails',
                        text: 'Emails'
                    },
                    {
                        id: 'portals',
                        url: '/people/' + this.person.data.id + '/portals',
                        text: 'Portals'
                    },
                  {
                    id: 'partnership-activity-mails',
                    url: '/people/' + this.person.data.id + '/partnership-activity-mails',
                    text: 'Activity Mails'
                  },
                    {
                        id: 'timeline',
                        url: '/people/' + this.person.data.id + '/timeline',
                        text: 'Timeline'
                    },
                ]
            },

            active() {
                return this.getMeta('subsection')
            }
        }
    }
</script>
